/**
 * @props device: 'desktop' (String)
 * @props onChange: (Function)
 * @props style: {} (Object)
 * @return Selected device
 */

import { useState } from '@wordpress/element';

import './BDevice.scss';
import { desktopIcon, tabletIcon, mobileIcon } from './Helper/icons';

const BDevice = ({ onChange, device = 'desktop', style, className = 'iconButton' }) => {
	const [show, setShow] = useState(false);

	window.addEventListener('click', () => setShow(false));

	return <div className={'bDevice'} style={style}>
		{!show && <button className={className} title={device[0].toUpperCase() + device.slice(1)} onClick={(event) => {
			setShow(true);
			event.stopPropagation();
		}}>
			{device == 'desktop' ? desktopIcon : device == 'tablet' ? tabletIcon : mobileIcon}
		</button>}

		{show && <div className={'bDevicePopup'}>
			{/* {device != 'desktop' && ( */}
			<button className={className} title='Desktop' onClick={() => {
				onChange('desktop');
				setShow(false);
			}}>{desktopIcon}</button>
			{/* // )} */}

			{/* {device != 'tablet' && ( */}
			<button className={className} title='Tablet' onClick={() => {
				onChange('tablet');
				setShow(false);
			}}>{tabletIcon}</button>
			{/* )} */}

			{/* {device != 'mobile' && ( */}
			<button className={className} title='Mobile' onClick={() => {
				onChange('mobile');
				setShow(false);
			}}>{mobileIcon}</button>
			{/* )} */}
		</div>}
	</div>
};
export default BDevice;